import { User } from "shared/user/types";

export const apiDailyMinutesLogMinuteUsedPath = `/api/daily-minutes/log-minute-used`;
export type ApiDailyMinutesLogMinuteUsedResponse = User;
